import styled, { css } from 'styled-components';
import { NoSelect, Transitions } from '../../../../styles/mixins';

export const SliderContainer = styled.div<{ disabled?: boolean }>`
  min-height: 80px;
  position: relative;
  width: 100%;
  cursor: pointer;
  padding-top: 16px;
  ${NoSelect};
  display: flex;
  flex-direction: column;

  &:first-child {
    padding-top: 0;
  }

  .add-transition {
    ${Transitions}
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `}
`;

const hideSliderValues = css`
  .slider {
    > div {
      > div:first-child {
        display: none;
      }
    }
  }
`;

export const SliderContainerStyled = styled.div`
  position: relative;
  min-height: 20px;
  ${NoSelect}
  ${hideSliderValues};
`;
